import PropTypes from "prop-types";

const SubmitQuizButton = ({ onSubmit, disabled, isSubmitting, label }) => {
  const isDisabled = disabled || isSubmitting;

  return (
    <button
      type="button"
      onClick={onSubmit}
      disabled={isDisabled}
      aria-busy={isSubmitting}
      className={`
        w-full
        md:w-auto
        px-6
        py-3
        rounded-lg
        font-semibold
        transition-all

        ${
          isDisabled
            ? "bg-gray-300 text-gray-600 cursor-not-allowed"
            : "bg-blue-600 text-white hover:bg-blue-700"
        }
      `}
    >
      {isSubmitting ? "Submitting..." : (label ?? "Submit Quiz")}
    </button>
  );
};

SubmitQuizButton.propTypes = {
  onSubmit: PropTypes.func.isRequired,

  disabled: PropTypes.bool,

  isSubmitting: PropTypes.bool,

  label: PropTypes.string,
};

SubmitQuizButton.defaultProps = {
  disabled: false,

  isSubmitting: false,

  label: "Submit Quiz",
};

export default SubmitQuizButton;
